import React from 'react';
import '../Library/Library.css'; // library-tabs, library-panel
import '../Settings/Scenarios/Scenarios.css'; // scenarios-title
import '../ActivityLog/ActivityLog.css'; // the platform screen's usage bar and legend

const SCOPES = [{ key: 'you', label: 'You' }, { key: 'org', label: 'Organization' }];

// Each part takes its category chip's colour, so the bar and the log's chips
// read as one system; what's left is the bar's own track.
const partColour = (part) => (part.chip ? `var(--color-surface-chip-${part.chip})` : 'var(--color-neutral-200)');

/**
 * Token usage above the Activity log, matched to the platform's Activity Log
 * card: You or Organization, the total, the allowance (in error once it's
 * over), the bar by category with its legend, and pages across runs.
 */
function ActivityUsage({ usage, scope, onScopeChange }) {
  return (
    <section className="activities-section" aria-labelledby="activities-usage-title">
      <h2 id="activities-usage-title" className="scenarios-title activities-title">Token usage</h2>
      <div className="library-panel activities-usage">
        <div className="library-tabs activities-usage-tabs">
          {SCOPES.map(({ key, label }) => {
            const active = scope === key;
            return (
              <button
                key={key}
                type="button"
                className={`library-tab${active ? ' is-active' : ''}`}
                aria-current={active ? 'true' : undefined}
                data-label={label}
                onClick={() => onScopeChange(key)}
              >
                {label}
              </button>
            );
          })}
        </div>

        <div className="activities-usage-total"><strong>{usage.total}</strong> tokens used · {usage.window}</div>
        <div className={`activities-usage-allowance${usage.over ? ' is-over' : ''}`}>
          {usage.allowanceLabel}: <strong>{usage.used}</strong> of <strong>{usage.allowance}</strong> used
          {usage.over && <> · <strong>over allowance</strong></>}
        </div>

        <div className="activity-token-bar" role="img" aria-label="Token usage by category">
          {usage.parts.map((p) => (
            <span key={p.label} className="activity-token-seg" style={{ width: `${p.pct}%`, background: partColour(p) }} />
          ))}
        </div>
        <div className="activity-token-legend">
          {usage.parts.map((p) => (
            <span key={p.label} className="activity-token-legend-item">
              <span className="activity-token-dot" style={{ background: partColour(p) }} aria-hidden="true" />
              {p.label} <strong>{p.value}</strong>
            </span>
          ))}
        </div>

        <div className="activities-usage-foot">{usage.pages} across {usage.runs}</div>
      </div>
    </section>
  );
}

export default ActivityUsage;
